export default "__VITE_ASSET__CAEMc$GZ__"